import { googleService } from '../../../services';

/**
 * Kullanıcının bağlamak istediği Google hesabının sistemde var olup olmadığını 
 * kontrol eder ve var olan hesaplarla çakışma olmaması için uyarır.
 * 
 * @param {string} email - Google hesabı e-posta adresi
 * @returns {Promise<boolean>} - Hesap zaten mevcut mu
 */
export const checkDuplicateAccount = async (email) => {
  if (!email) return false;
  
  try {
    // Google hesabı zaten mevcut mu kontrol et
    return await googleService.checkDuplicateAccount(email);
  } catch (error) {
    console.error('Google hesabı duplicate kontrolü sırasında hata:', error);
    return false;
  }
};